import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  IconButton as MuiIconButton,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";

// Import all resume components
import Resume1 from "../DuplicateResume/Resume1";
import Resume2 from "../DuplicateResume/Resume2";
import Resume3 from "../DuplicateResume/Resume3";
import Resume4 from "../DuplicateResume/Resume4";
import Resume5 from "../DuplicateResume/Resume5";
import Resume6 from "../DuplicateResume/Resume6";
import Resume7 from "../DuplicateResume/Resume7";
import Resume8 from "../DuplicateResume/Resume8";
import Resume9 from "../DuplicateResume/Resume9";
import Resume10 from "../DuplicateResume/Resume10";
import Resume11 from "../DuplicateResume/Resume11";
import Resume12 from "../DuplicateResume/Resume12";
import Resume13 from "../DuplicateResume/Resume13";
import Resume14 from "../DuplicateResume/Resume14";
import Resume15 from "../DuplicateResume/Resume15";
import Resume16 from "../DuplicateResume/Resume16";
import Resume17 from "../DuplicateResume/Resume17";
import Resume18 from "../DuplicateResume/Resume18";
import Resume19 from "../DuplicateResume/Resume19";
import Resume20 from "../DuplicateResume/Resume20";  
import Resume21 from "../DuplicateResume/Resume21";
import Resume22 from "../DuplicateResume/Resume22";
import Resume23 from "../DuplicateResume/Resume23";
import Resume24 from "../DuplicateResume/Resume24";
import Resume25 from "../DuplicateResume/Resume25";
import Resume26 from "../DuplicateResume/Resume26";
import Resume27 from "../DuplicateResume/Resume27";
import Resume28 from "../DuplicateResume/Resume28";
import Resume29 from "../DuplicateResume/Resume29";
import Resume30 from "../DuplicateResume/Resume30";
import Resume31 from "../DuplicateResume/Resume31";
import Resume32 from "../DuplicateResume/Resume32";
import Resume33 from "../DuplicateResume/Resume33";
import Resume34 from "../DuplicateResume/Resume34";
import Resume35 from "../DuplicateResume/Resume35";
import Resume36 from "../DuplicateResume/Resume36";
import Resume37 from "../DuplicateResume/Resume37";
import Resume38 from "../DuplicateResume/Resume38";
import Resume39 from "../DuplicateResume/Resume39";
import Resume40 from "../DuplicateResume/Resume40";

import Resume41 from "../DuplicateResume/Resume41";
import Resume42 from "../DuplicateResume/Resume42";
import Resume43 from "../DuplicateResume/Resume43";
import Resume44 from "../DuplicateResume/Resume44";
import Resume45 from "../DuplicateResume/Resume45";
import Resume46 from "../DuplicateResume/Resume46";
import Resume47 from "../DuplicateResume/Resume47";
import Resume48 from "../DuplicateResume/Resume48";
import Resume49 from "../DuplicateResume/Resume49";
import Resume50 from "../DuplicateResume/Resume50";

import Sidebar from "../Sidebar";

const steps = [
  "Heading",
  "Work history",
  "Education",
  "Skills",
  "Summary",
  "Finalize",
];

const templateComponents = {
  1: Resume1,
  2: Resume2,
  3: Resume3,
  4: Resume4,
  5: Resume5,
  6: Resume6,
  7: Resume7,
  8: Resume8,
  9: Resume9,
  10: Resume10,
  11: Resume11, 
  12: Resume12,
  13: Resume13,
  14: Resume14,
  15: Resume15,
  16: Resume16,
  17: Resume17,
  18: Resume18,
  19: Resume19,
  20: Resume20,
  21: Resume21,
  22: Resume22,
  23: Resume23,
  24: Resume24,
  25: Resume25,
  26: Resume26,
  27: Resume27,
  28: Resume28,
  29: Resume29,
  30:Resume30,
  31:Resume31,
  32:Resume32,
  33:Resume33,
  34:Resume34,
  35:Resume35,
  36:Resume36,
  37:Resume37,
  38:Resume38,
  39:Resume39,
  40:Resume40,
  41:Resume41,
  42:Resume42,
  43:Resume43,
  44:Resume44,
  45:Resume45,
  46:Resume46,
  47:Resume47,
  48:Resume48,
  49:Resume49,
  50:Resume50,
};

const WorkHistoryTips = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Persist template/theme across navigation
  const [selectedTemplate, setSelectedTemplate] = useState(() => {
    const navTemplate = location.state?.selectedTemplate;
    if (navTemplate) {
      localStorage.setItem("selectedTemplate", navTemplate);
      return navTemplate;
    }
    return localStorage.getItem("selectedTemplate") || 1;
  });
  const [selectedTheme, setSelectedTheme] = useState(() => {
    const navTheme = location.state?.selectedTheme;
    const parseTheme = (t) => {
      if (!t) return null;
      if (typeof t === 'string') return t;
      if (typeof t === 'object') return t.primary || t.color || t.highlight || t.primary?.main || t.hex || null;
      return null;
    };

    const fromNav = parseTheme(navTheme);
    if (fromNav) {
      localStorage.setItem('selectedTheme', fromNav);
      return fromNav;
    }

    const stored = localStorage.getItem('selectedTheme');
    if (!stored) return '#1a2b47';
    try {
      const parsed = JSON.parse(stored);
      const fromParsed = parseTheme(parsed);
      return fromParsed || stored || '#1a2b47';
    } catch {
      return stored;
    }
  });

  // If navigation state changes and has new template/theme, update state and localStorage
  useEffect(() => {
    if (location.state) {
      const { selectedTemplate: template, selectedTheme: theme } = location.state;
      if (template) {
        setSelectedTemplate(template);
        localStorage.setItem("selectedTemplate", template);
      }
      if (theme) {
        const normalized = typeof theme === 'string' ? theme : (theme.primary || theme.color || theme.highlight || theme.primary?.main || theme.hex || null);
        if (normalized) {
          setSelectedTheme(normalized);
          localStorage.setItem('selectedTheme', normalized);
        }
      }
    }
  }, [location.state]);
  
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    currentPosition:"",
    city: "",
    country: "India",
    pinCode: "",
    phone: "",
    email: "",
    linkedIn: "",
    website: "",
    drivingLicence: "",
  });
  const [preview, setPreview] = useState("");
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);

  // ---- NEW: mobile full-size preview scaling (measures the ACTUAL
  // rendered resume width instead of assuming a fixed 794px, which was
  // causing leftover white space for templates narrower than 794px) ----
  const previewContentRef = useRef(null);
  const MOBILE_PREVIEW_GUTTER = 16; // small left/right gutter, px per side
  const [mobilePreviewSize, setMobilePreviewSize] = useState({
    scale: 1,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    if (!openPreviewDialog || !isMobile) return;

    const measure = () => {
      if (previewContentRef.current) {
        // scrollWidth/scrollHeight reflect the resume's true layout size,
        // regardless of any transform applied to it.
        const naturalWidth = previewContentRef.current.scrollWidth;
        const naturalHeight = previewContentRef.current.scrollHeight;
        const availableWidth =
          window.innerWidth - MOBILE_PREVIEW_GUTTER * 2;

        if (naturalWidth > 0) {
          const scale = availableWidth / naturalWidth;
          setMobilePreviewSize({
            scale,
            width: naturalWidth * scale,
            height: naturalHeight * scale,
          });
        }
      }
    };

    // slight delay so the resume component finishes rendering first
    const timer = setTimeout(measure, 100);
    window.addEventListener("resize", measure);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", measure);
    };
  }, [openPreviewDialog, isMobile, selectedTemplate, selectedTheme]);

  // Load selected template + user data
  useEffect(() => {
    if (location.state) {
      const { selectedTemplate: template, selectedTheme: theme } = location.state;
      if (template) setSelectedTemplate(template);
      if (theme) setSelectedTheme(theme);
    }

    // Fetch contact data
    const fetchContactData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const res = await axios.get("https://resume-maker-lc.onrender.com/api/contact/me", {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data) {
          setFormData({
            firstName: res.data.firstName || "",
            lastName: res.data.lastName || "",
            currentPosition:res.data.currentPosition ||"",
            city: res.data.city || "",
            country: res.data.country || "India",
            pinCode: res.data.pinCode || "",
            phone: res.data.phone || "",
            email: res.data.email || "",
            linkedIn: res.data.linkedIn || "",
            website: res.data.website || "",
            drivingLicence: res.data.drivingLicence || "",
          });

          if (res.data.photo) {
            setPreview(
              res.data.photo.startsWith("http")
                ? res.data.photo
                : `https://resume-maker-lc.onrender.com${res.data.photo}`
            );
          }
        }
      } catch (err) {
        console.error("Error fetching contact", err);
      }
    };

    fetchContactData();
  }, [location.state]);

  const SelectedResumeComponent = templateComponents[selectedTemplate];

  const getResumeProps = () => {
    switch (selectedTemplate) {
      case 2:
        return { color: selectedTheme, formData, photo: preview };
      case 3:
        return {
          color: typeof selectedTheme === "object" ? selectedTheme.primary : selectedTheme,
          formData,
          photo: preview,
        };
      case 4:
        return {
          theme: selectedTheme,
          color: typeof selectedTheme === "object" ? selectedTheme.primary : selectedTheme,
          formData,
          photo: preview,
        };
      case 7:
        return {
          theme: selectedTheme,
          color: typeof selectedTheme === "object" ? selectedTheme.highlight : selectedTheme,
          formData,
          photo: preview,
        };
      case 8:
        return { theme: selectedTheme, formData, photo: preview };
      default:
        return { color: selectedTheme, formData, photo: preview };
    }
  };

  const handleOpenPreview = () => {
    setOpenPreviewDialog(true);
  };

  const handleClosePreview = () => {
    setOpenPreviewDialog(false);
  };

  // Handle Go Back navigation to WorkHistry
  const handleGoBack = () => {
    navigate("/WorkHistry", {
      state: { selectedTemplate, selectedTheme },
    });
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar />

      {/* Main content area — pushed right of sidebar */}
      <Box
        sx={{
          ml: { xs: "90px", sm: "240px" },
          width: { xs: "calc(100% - 60px)", sm: "calc(100% - 240px)" },
          minHeight: "100vh",
          p: { xs: 1.5, sm: 3 },
          boxSizing: "border-box",
          backgroundColor: "#EFF7FF",
        }}
      >
        {/* Back Button */}
        <Typography
          variant="body2"
          sx={{
            color: "#002B5B",
            fontWeight: "bold",
            mb: 1,
            cursor: "pointer",
            "&:hover": {
              color: "#0288D1",
              textDecoration: "underline",
            },
            transition: "color 0.3s ease",
            fontSize: isSmallMobile ? "0.875rem" : "inherit",
          }}
          onClick={handleGoBack}
        >
          ← Go Back
        </Typography>

        {/* Title */}
        <Typography 
          variant={isMobile ? "h6" : "h5"} 
          fontWeight="bold" 
          gutterBottom
          sx={{ fontSize: isSmallMobile ? "1.25rem" : "inherit" }}
        >
          Now, let's fill out your
        </Typography>
        <Typography 
          variant={isMobile ? "h5" : "h4"} 
          fontWeight="bold" 
          gutterBottom
          sx={{ fontSize: isSmallMobile ? "1.5rem" : "inherit" }}
        >
          Experience
        </Typography>

        {/* Subtitle */}
        <Typography 
          variant="subtitle1" 
          fontWeight="bold" 
          gutterBottom
          sx={{ fontSize: isSmallMobile ? "1rem" : "inherit", color: "#0288D1" }}
        >
          Here's what you need to know:
        </Typography>
        <Typography 
          variant="body1" 
          color="text.secondary" 
          gutterBottom
          sx={{ 
            fontSize: isSmallMobile ? "0.875rem" : "inherit",
            lineHeight: 1.6,
          }}
        >
          You can include any work experience, internships, scholarships,
          relevant coursework and academic achievements.
        </Typography>

        {/* Resume Preview */}
        <Box
          sx={{
            mt: isMobile ? 3 : 4,
            display: "flex",
            justifyContent: isMobile ? "flex-start" : "center",
            maxHeight: isMobile ? 300 : 400,
            overflow: "hidden",
            paddingLeft: isMobile ? "10%" : 0,
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: 600,
              transform: isSmallMobile ? "scale(0.25)" : isMobile ? "scale(0.3)" : "scale(0.3)",
              transformOrigin: isMobile ? "top left" : "top center",
            }}
          >
            <SelectedResumeComponent {...getResumeProps()} />
          </Box>
        </Box>

        {/* Bottom Navigation */}
        <Box
          sx={{
            mt: isMobile ? 4 : 6,
            display: "flex",
            gap: 3,
            flexDirection: isMobile ? "row" : "row",
            alignItems: "center",
            justifyContent: isMobile ? "space-between" : "center",
            width: "100%",
            maxWidth: isMobile ? "100%" : "400px",
            margin: isMobile ? "0" : "0 auto",
          }}
        >
          <Button 
            variant="outlined" 
            sx={{ 
              px: isMobile ? 3 : 5, 
              borderRadius: 3, 
              fontWeight: "bold", 
              height: 45,
              width: isMobile ? "48%" : "auto",
              minWidth: isMobile ? "auto" : 120,
              borderColor: "#002B5B",
              color: "#002B5B",
              "&:hover": {
                borderColor: "#0288D1",
                color: "#0288D1",
                backgroundColor: "rgba(2, 136, 209, 0.04)",
              }
            }}
            onClick={handleOpenPreview}
          >
            Preview
          </Button>
          <Button
            variant="contained"
            sx={{
              px: isMobile ? 3 : 5,
              borderRadius: 3,
              fontWeight: "bold",
              height: 45,
              backgroundColor: "#002B5B",
              width: isMobile ? "48%" : "auto",
              minWidth: isMobile ? "auto" : 120,
              "&:hover": { 
                backgroundColor: "#0288D1",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 12px rgba(2, 136, 209, 0.3)",
              },
              transition: "all 0.3s ease",
            }}
            onClick={() =>
              navigate("/WorkHistrySummary", {
                state: { selectedTemplate, selectedTheme },
              })
            }
          >
            Next
          </Button>
        </Box>
      </Box>

      {/* Preview Dialog */}
      <Dialog
        open={openPreviewDialog}
        onClose={handleClosePreview}
        maxWidth="lg"
        fullWidth
        fullScreen={isMobile}
        PaperProps={{
          sx: {
            borderRadius: isMobile ? 0 : 2,
            maxHeight: isMobile ? "100%" : "90vh",
            overflow: "hidden",
          }
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "#f5f5f5",
            borderBottom: "1px solid #e0e0e0",
            py: 2,
            px: isMobile ? 2 : 3,
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Resume Preview
          </Typography>
          <MuiIconButton
            onClick={handleClosePreview}
            size="small"
            sx={{
              color: "text.secondary",
              "&:hover": {
                color: "#0288D1",
                backgroundColor: "rgba(2, 136, 209, 0.04)",
              }
            }}
          >
            <CloseIcon />
          </MuiIconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            padding: isMobile ? "0 !important" : 4,
            overflow: "auto",
            backgroundColor: isMobile ? "#ffffff" : "#fafafa",
          }}
        >
          {isMobile ? (
            <Box
              sx={{
                width: "100%",
                minWidth: "100%",
                overflowX: "auto",
                overflowY: "auto",
                backgroundColor: "#ffffff",
                boxSizing: "border-box",
                // small left/right gutter only — keeps the resume from
                // touching the screen edges, on mobile preview only
                px: `${MOBILE_PREVIEW_GUTTER}px`,
              }}
            >
              <Box
                sx={{
                  // sized exactly to the scaled resume so no leftover
                  // blank space shows up on the right (or anywhere)
                  width: mobilePreviewSize.width || "100%",
                  height: mobilePreviewSize.height || "auto",
                  overflow: "hidden",
                }}
              >
                <Box
                  ref={previewContentRef}
                  sx={{
                    transform: `scale(${mobilePreviewSize.scale})`,
                    transformOrigin: "top left",
                  }}
                >
                  <SelectedResumeComponent {...getResumeProps()} />
                </Box>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                width: "100%",
                maxWidth: 1000,
                transform: "scale(1)",
                transformOrigin: "top center",
                transition: "transform 0.3s ease",
                boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                borderRadius: 1,
                backgroundColor: "white",
                padding: 3,
              }}
            >
              <SelectedResumeComponent {...getResumeProps()} />
            </Box>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            padding: isMobile ? 2 : 3,
            backgroundColor: "#f5f5f5",
            borderTop: "1px solid #e0e0e0",
          }}
        >
          <Button
            onClick={handleClosePreview}
            variant="contained"
            sx={{
              backgroundColor: "#002B5B",
              "&:hover": {
                backgroundColor: "#0288D1",
              },
              fontWeight: "bold",
              borderRadius: 2,
              px: 4,
              py: 1,
            }}
          >
            Close Preview
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
 
export default WorkHistoryTips;